export interface AnalyticFunctionParam {
	/** Text read on param to user */
	name: string;
	/** Looker's param identifier */
	param: string;
	/** Type of param */
	type: 'integer';
	/** Type of unit displayed next to name field */
	unit?: string;
	/** Whether or not there should be a default value */
	default?: number;
}

export interface AnalyticFunction {
	/** Display name for the function */
	name: string;
	/** Looker's function identifier */
	function: string;
	/** Description as provided by looker */
	description: string;
	/** Optional list of params for a function */
	params?: AnalyticFunctionParam[];
}

export type AnalyticFunctionsStoreState = AnalyticFunction[];
